<template>
  <div class="bg-white h-100">
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <section class="py-2 px-3">
      <LmDatePicker
        :showComponent="true"
        :showTime="true"
        :config="{
          dateFormat: dateFormat,
          allowInput: true,
          minDate: 'today'
        }"
        :label="$t('select_expiration_date')"
        v-model="newExpirationDate"
      />
      <LmButton
        :disabled="!hasChanged"
        :value="$t('apply')"
        type="button"
        buttonClass="btn-info"
        @click="onUpdateExpirationDate"
      />
    </section>
  </div>
</template>

<script>
import LmDatePicker from '@/components/form/elements/LmDatePicker'
import LmButton from '@/components/form/elements/LmButton'
import moment from 'moment'

export default {
  components: {
    LmDatePicker,
    LmButton
  },
  data () {
    return {
      newExpirationDate: null,
      originalExpirationDate: null,
      dateFormat: 'DD-MM-YYYY hh:mm:ss'
    }
  },
  computed: {
    hasChanged () {
      return this.originalExpirationDate !== this.newExpirationDate
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    expirationDate: {
      type: [Date, String, null],
      default: null
    }
  },
  methods: {
    onUpdateExpirationDate () {
      const dateToEmit = moment(this.newExpirationDate, this.dateFormat).toDate()
      this.$emit('onUpdateExpirationDate', dateToEmit)
      this.$emit('close')
    }
  },
  created () {
    if (this.expirationDate) {
      this.originalExpirationDate = moment(this.expirationDate).format(this.dateFormat)
      this.newExpirationDate = this.originalExpirationDate
    }
  }
}
</script>
